import React, { useState, forwardRef } from "react";
import { Eye, EyeOff } from "lucide-react";
import { Input } from "./ui/input";

// Password input with an eye toggle so the user can preview whatever they
// typed. Type flips between "password" and "text". Test id passes through
// unchanged, and the eye button exposes `<data-testid>-toggle` so tests can
// drive the reveal.
const PasswordInput = forwardRef(function PasswordInput(
  { className = "", "data-testid": testId, ...props },
  ref,
) {
  const [show, setShow] = useState(false);
  const toggleId = testId ? `${testId}-toggle` : undefined;
  return (
    <div className="relative">
      <Input
        ref={ref}
        type={show ? "text" : "password"}
        // Right padding keeps the value clear of the eye button.
        className={"pr-10 " + className}
        data-testid={testId}
        {...props}
      />
      <button
        type="button"
        onClick={() => setShow((s) => !s)}
        tabIndex={-1}
        aria-label={show ? "Hide password" : "Show password"}
        aria-pressed={show}
        data-testid={toggleId}
        className="absolute right-2 top-1/2 -translate-y-1/2 inline-flex h-7 w-7 items-center justify-center rounded-md text-muted-foreground hover:text-foreground hover:bg-muted/50 transition-colors"
      >
        {show ? <EyeOff size={15} /> : <Eye size={15} />}
      </button>
    </div>
  );
});

export default PasswordInput;
